var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unknown_icon_32x32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#808080",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "NA",
    transform: "translate(4.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "N",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "N-shape",
    fill: "#FFFFFF",
    points: "0 0 3 0 7 10 7 0 10 0 10 16 7 16 3 6 3 16 0 16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "A",
    transform: "translate(14.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "A-shape",
    fill: "#FFFFFF",
    points: "0 16 2.5 16 3 14 7 14 7.5 16 10 16 6 0 4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "A-crossbar",
    fill: "#FFFFFF",
    points: "4 9 6 9 5.5 7.5 4.5 7.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownIcon);
export default __webpack_public_path__ + "static/media/unknown_icon.4fa43f152c9e5213b0dd85afaf66cb48.svg";
export { ForwardRef as ReactComponent };